import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
    deleteDocument,
    generateCustomID,
    saveData,
    uniqueID,
    uploadImage,
} from "../../../firebase/utility";

const useCategoryHook = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const { all_categories } = useSelector((state) => state.redux);
    const { user } = useSelector((state) => state.auth);
    const [allCategories, setAllCategories] = useState(all_categories ?? []);
    const [allDuplicateCategories, setAllDuplicateCategories] = useState(all_categories ?? []);
    const [searchValue, setSearchValue] = useState(localStorage.getItem("categorySearch") || "");
    const [canSearch, setCanSearch] = useState(!!localStorage.getItem("categorySearch"));
    const [selectedCategory, setSelectedCategory] = useState(null);

    const toggleModal = () => {
        setModalOpen((prev) => !prev);
    };

    // Function to handle search data
    const handleOnSearchData = () => {
        let text = searchValue.trim();
        let filteredCategories = [...allDuplicateCategories];
        if (text?.length > 0) {
            filteredCategories = filteredCategories.filter((item) => {
                const search = `${item?.id} ${item?.categoryName} `;
                const searchUserQuery = search.toUpperCase();
                const textData = text.toUpperCase();
                return searchUserQuery.indexOf(textData) > -1;
            });
        }
        setAllCategories(filteredCategories);
    };

    const submitCategory = async (formData, resetForm, setLoading) => {
        try {
            setLoading(true);
            const _id = selectedCategory?._id ?? uniqueID();
            let img = formData?.category_image;
            let imageUrl;
            if (img != undefined && typeof img === "object") {
                imageUrl = formData.category_image
                    ? await uploadImage(formData.category_image, "CategoryImages")
                    : null;
            } else {
                imageUrl = formData.category_image;
            }

            const categoryData = {
                _id,
                categoryName: formData.category,
                categoryType: formData.category_type,
                categoryImage: imageUrl || null,
                id: selectedCategory?.id ?? (await generateCustomID("Categories")),
                categoryImageURL: formData?.categoryImageURL ?? "",
            };
            if (selectedCategory?._id) {
                categoryData.updatedAt = Date.parse(new Date());
                categoryData.updatedBy = { _id: user?._id || "", username: user?.username || "", email: user?.email || "" };
                categoryData.createdAt = selectedCategory?.createdAt ?? null;
                categoryData.createdBy = selectedCategory?.createdBy ?? null;
            } else {
                categoryData.createdAt = Date.parse(new Date());
                categoryData.createdBy = { _id: user?._id || "", username: user?.username || "", email: user?.email || "" };
            }

            const result = await saveData("Categories", _id, {
                _id: categoryData?._id,
                ...categoryData,
            });
            if (result) {
                toast.success(`${formData?.category} Category Saved successfully.`);
                resetForm();
                toggleModal();
            } else {
                toast.error("Failed to add category.");
            }
        } catch (err) {
            toast.error("An error occurred. Please try again.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = (id) => {
        if (id) {
            deleteDocument("Categories", id).then(() => {
                toast.success(`Category Deleted Successfully`);
            });
        }
    };

    useEffect(() => {
        if (canSearch) {
            localStorage.setItem("categorySearch", searchValue);
        }
        const delayDebounceFn = setTimeout(() => {
            if (canSearch || searchValue.length > 0) {
                handleOnSearchData();
            }
        }, 1000);
        return () => clearTimeout(delayDebounceFn);
    }, [searchValue, canSearch, allDuplicateCategories]);

    useEffect(() => {
        if (all_categories?.length > 0) {
            setAllCategories(all_categories ?? []);
            setAllDuplicateCategories(all_categories ?? []);
        }
    }, [all_categories]);
    return {
        modalOpen,
        allCategories,
        handleDelete,
        submitCategory,
        setSelectedCategory,
        modalOpen,
        toggleModal,
        selectedCategory,
        searchValue,
        setSearchValue,
        canSearch,
        setCanSearch,
    };
};

export default useCategoryHook;
